import { FrameworkContext } from "global/cnr/contexts/FrameworkContent";
import { LongPressContext, LongPressProvider } from "global/cnr/contexts/LongPressContext";
import { ParentContext } from "global/cnr/contexts/ParentContext";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { useLongPress } from "global/cnr/contexts/useHelpers/useLongPress";
import { useSwiperControl } from "global/cnr/contexts/useHelpers/useSwiperControl";
import FullImage from "global/components/imaging/FullImage";
import { gEnums } from "global/enums/globalEnums";
import React, { useContext, useMemo, useState } from "react";
import LongPressModal from "./LongPressModal";

const _allow_appUserLongPressDirect = true
const _show_OptionsFromLongPress = true

// export const LongPressContext = createContext();

export const _longPressTypes = {
  appUser: 'appUser',
  bannerImage: 'bannerImage',
  default: 'default',
  header: 'header',
  image_grid: 'image_grid',
  image: 'image',
  item: 'item',
  match: 'match',
  tab: 'tab',
  pageNav: 'pageNav',
}

export const _longPressDisplayTypes = {
  partial: 'partial',
  full: 'full'
}

export const LongPressWrapper = ({
  apn,
  children,
  onClick,
  pressTime = 1000,
  moveTolerance = 15,
  longPressType = _longPressTypes.item,
  longPressDisplayType = _longPressDisplayTypes.full,
  itemData,
  hasImage = false,
  handleOnPress = null,
  longPressModal,
  opts,
  disallowLpw,
  isHolding = false,
  allowHoldingStart = false,
}) => {

  const appUserAccess = null // useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const longPressContext = useContext(LongPressContext);
  const { longPress_state, longPress_handlers } = longPressContext ?? {}
  const { showLongPressModal } = longPress_state ?? {}
  const { handleShowLongPressModal } = longPress_handlers ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states

  const fraweworkContext = useContext(FrameworkContext)
  const { framework_handlers } = fraweworkContext ?? {}

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appSettings } = aps_global ?? {}
  const { showOptionsFromLongPress, allowAppUserLongPressDirect } = appSettings ?? {}

  const _allowAppUserLongPressDirect = isAdminOrSuper || allowAppUserLongPressDirect || _allow_appUserLongPressDirect
  const _showOptionsFromLongPress = isAdminOrSuper || showOptionsFromLongPress || _show_OptionsFromLongPress

  const _pressTime = useMemo(() => {
    switch (longPressType) {
      case _longPressTypes.appUser:
        return _allowAppUserLongPressDirect ? 0 : pressTime;
      case _longPressTypes.pageNav:
        return 0
      default:
        return pressTime
    }
  }, [longPressType, pressTime])

  const frameworkContext = useContext(FrameworkContext)
  const { framework_state } = frameworkContext ?? {}
  const { view, fw_info } = framework_state ?? {}
  const { uivi } = fw_info ?? {}

  const { lockSwiper, unlockSwiper } = useSwiperControl()

  const [showItemImage, setShowItemImage] = useState()
  const [isPressStart, setIsPressStart] = useState()

  const handleShowItemImage = () => setShowItemImage(!showItemImage)

  const access = useMemo(() => {
    if (!appUserAccess) { return { any: true } }
    const _access = {
      appProfile: appUserAccess.accessLevel >= gEnums.allAuthLevels.appProfile.value,
      auth: appUserAccess.accessLevel >= gEnums.allAuthLevels.superAdmin.value,
      data: appUserAccess.accessLevel >= gEnums.allAuthLevels.appDataAdmin.value,
      settings: appUserAccess.accessLevel >= gEnums.allAuthLevels.appAdmin.value,
    }
    switch (longPressType) {
      case _longPressTypes.appUser:
        _access.any = _access.auth || _access.data || _access.settings || _access.appProfile
        break;
      case _longPressTypes.pageNav:
        _access.any = true
        break;
      default:
        _access.any = _access.auth || _access.data || _access.settings
    }
    return _access
  }, [appUserAccess, longPressType])

  // const ignoreOverlay = useMemo(() => {
  //   switch (longPressType) {
  //     case _longPressTypes.appUser:
  //     case _longPressTypes.match:
  //       return false
  //     case _longPressTypes.item:
  //     case _longPressTypes.tab:
  //     case _longPressTypes.header:
  //     case _longPressTypes.image_grid:
  //     case _longPressTypes.bannerImage:
  //     case _longPressTypes.image:
  //     case _longPressTypes.bannerImage:
  //       return true
  //   }
  // }, [longPressType])

  // this will trigger when long pressed
  const handlePress = (e) => {
    if (!_showOptionsFromLongPress || !access.any || disallowLpw) return;
    lockSwiper && lockSwiper()
    // if handleOnPress is a prop, trigger that.
    if (handleOnPress) {
      handleOnPress()
    } else {

      framework_handlers.handleSet_currentLongPress(
        {
          longPressType,
          view: view,
          viewKey: fw_info?.viewKey,
          uivi: uivi,
          uiviKey: itemData?._itemKey,
          longPressData: itemData
        })


      switch (longPressType) {
        case _longPressTypes.appUser:
        case _longPressTypes.bannerImage:
        case _longPressTypes.header:
        case _longPressTypes.image_grid:
        case _longPressTypes.item:
        case _longPressTypes.match:
        case _longPressTypes.tab:
        case _longPressTypes.pageNav:
          handleShowLongPressModal()
          break;
        case _longPressTypes.image:
        case _longPressTypes.bannerImage:
          handleShowItemImage()
          break;
        // case _longPressTypes.match:
        // framework_handlers.handleShow_appBottomModal(longPressModal)
        // break;
      }

    }
  }

  const handlePressShort = (value) => {
    if (allowHoldingStart) {
      setIsPressStart(value)
    }
  }

  const handleClick = (e) => {
    unlockSwiper && unlockSwiper()
    onClick && onClick(e)
  }

  const handleRelease = (e) => {
    unlockSwiper && unlockSwiper()
  }

  const longPress = useLongPress(
    {
      onLongPress: handlePress,
      onClick: handleClick,
      pressTime: _pressTime,
      moveTolerance,
      longPressType,
      onRelease: handleRelease,
      onLongPressShort: allowHoldingStart ? handlePressShort : null,
      isHolding: false,
    }
  );

  const appImage = () => {
    const { appImage } = opts ?? {}
    return <FullImage _appImage={appImage} handleClose={handleShowItemImage} />
  }

  const wrappedChild = useMemo(() => {
    return React.cloneElement(children, {
      ...children.props,
      ...longPress,
      className: [
        children.props?.className,
        longPress?.className,
        isPressStart && 'lpwh'
        // longPress?.isHolding && "lpwh",
      ]
        .filter(Boolean)
        .join(" "),
      style: {
        ...(children.props?.style ?? {}),
        ...(longPress?.style ?? {}),
      },
    });
  }, [children, longPress, isPressStart]);

  return (
    <>
      {showLongPressModal && (
        <LongPressModal
          apn={apn}
          itemData={itemData}
          hasImage={hasImage}
          handleCancel={handleShowLongPressModal}
          longPressType={longPressType}
          longPressDisplayType={longPressDisplayType}
          longPressModal={longPressModal}
        />
      )}
      {showItemImage && appImage()}
      {/* {wrappedChild} */}
      {isPressStart ? <div style={{ border: '1px solid var(--off-black-5)', borderRadius: '8px' }}>{wrappedChild}</div>
        : wrappedChild}

    </>
  );
};

export const LPW = (props) => {
  return <LongPressProvider {...props}>
    <LongPressWrapper {...props}>
    </LongPressWrapper>
  </LongPressProvider>
}